export const HTTP_STATUS_UNAUTHORIZED = 401

export enum AuthStatus {
  Unauthorized = 'unauthorized',
  Expired = 'expired',
}
